import type { AxiosResponse } from "axios";
import { executePost } from "../../../../utils/appUtils";

const optOutModalAndReqPin = (isOptOutParams): Promise<AxiosResponse> => {
    const optOutModalAndReqPinApi = `/participant-web-services/rest/partialauth/optOutModalRequestPin/${isOptOutParams.optOut}`;
    return executePost(optOutModalAndReqPinApi, "optOutModalAndReqPinFault", { ...isOptOutParams });
};
export default optOutModalAndReqPin;
